module.exports = __webpack_public_path__ + "img/ukflag.50ad72d0.jpg";